import { action, makeObservable, observable, reaction } from 'mobx';
import { Feature } from 'ol';
import { PageModalController } from '../PageModalControlles';
import { CartogramTableStore } from './CartogramsTableStore';

export class CartogramsPageModalStore {
  @observable pageModalController: PageModalController;
  @observable cartogramTable: CartogramTableStore;

  dispose?(): void;

  constructor() {
    this.pageModalController = new PageModalController();
    this.cartogramTable = new CartogramTableStore();

    makeObservable(this);
  }

  bind = () => {
    this.dispose = reaction(
      () => this.pageModalController.isActive,
      (isActive) => {
        if (!isActive) return this.cartogramTable.reset();
      },
    );

    this.cartogramTable.bind();
  };

  unbind = () => {
    this.dispose?.();
    this.cartogramTable.unbind();
  };

  @action
  open = ({
    cartogram,
    computeColumn,
    features,
  }: {
    cartogram: string;
    features: Feature[];
    computeColumn: string;
  }) => {
    this.cartogramTable.setCartogram(cartogram);
    this.cartogramTable.setFeatures(features);
    this.cartogramTable.setComputeColumn(computeColumn);
    this.pageModalController.open();
  };
}
